import React, { useState, useEffect } from "react";
import * as galaryService from "../../services/galary.services";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../common/loader";
import UseImageLoad from "../../common/imageloader";
import { Tooltip, Whisper } from "rsuite";
import Swal from "sweetalert2";
import {
  handleServerValidations,
  hasPermission,
  TrimText,
} from "../../../../utils/commonfunction";
import { SWAL_SETTINGS } from "../../../../utils/Constants";

const Galary = () => {
  const breadcrumbs = [
    { title: "Dashboard", url: "/admin/dashboard" },
    { title: "Media", url: "" },
  ];

  const [globalsearch, setGlobalSearch] = useState("");
  const [resetdate, setResetDate] = useState(false);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [offset, setOffset] = useState(0);
  const limit = 24;
  const [choosefiletype, setChooseFileType] = useState("");
  const navigate = useNavigate();

  const [fileType] = useState([
    { label: "Image", value: "image" },
    { label: "Video", value: "video" },
    { label: "Audio", value: "audio" },
    { label: "Docs", value: "docs" },
    { label: "Pdf", value: "pdf" },
    { label: "Excel", value: "excel" },
  ]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isLoading, offset, data]);

  const handleScroll = () => {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    const scrollHeight =
      document.documentElement.scrollHeight || document.body.scrollHeight;
    const clientHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;

    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight - 5;

    if (scrolledToBottom && !isLoading) {
      fetchMoreData();
    }
  };

  const fetchInitialData = async () => {
    setIsLoading(true);
    try {
      setOffset(0);
      const response = await galaryService.List({
        limit,
        offset: 0,
        filter: choosefiletype,
        global_search: globalsearch,
      });
      const imgarr = response?.data?.list || [];
      setData(imgarr);
      setOffset(limit); // prepare for next page
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchMoreData = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const response = await galaryService.List({
        limit,
        offset,
        filter: choosefiletype,
        global_search: globalsearch,
      });
      const imgarr = response?.data?.list || [];

      // Avoid duplicates
      setData((prevData) => {
        const filePaths = new Set(prevData.map((item) => item.filePath));
        const newItems = imgarr.filter((item) => !filePaths.has(item.filePath));
        return [...prevData, ...newItems];
      });

      setOffset((prevOffset) => prevOffset + limit);
    } catch (error) {
      console.error("Error fetching more data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, [choosefiletype, resetdate, globalsearch]);

  const resetFilter = (e) => {
    e.preventDefault();
    setChooseFileType("");
    setGlobalSearch("");
    setResetDate(!resetdate);
    $("#statusfilter")[0].selectedIndex = 0;
  };

  const handleFilterChange = (e) => {
    setChooseFileType(e.target.value);
  };

  const Deletefunction = (selectedItem) => {
    if (selectedItem) {
      Swal.fire({
        customClass: "swal-wide",
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#403fad",
        cancelButtonColor: "#f1388b",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          galaryService
            .Delete({ file_path: selectedItem?.filePath })
            .then((response) => {
              if (response.success) {
                Swal.fire({
                  icon: "success",
                  text: "Image deleted successfully",
                  ...SWAL_SETTINGS,
                });
                setData((prevData) =>
                  prevData.filter((image) => image.filePath !== selectedItem.filePath)
                );
              } else {
                Swal.fire({
                  icon: "error",
                  text: handleServerValidations(response),
                  ...SWAL_SETTINGS,
                });
              }
            })
            .catch((error) => {
              console.error("Error calling Delete API:", error);
            });
        }
      });
    }
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">Media</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder="Search"
                      onChange={(e) => setGlobalSearch(e.target.value)}
                    />
                  </div>
                </div>

                <div className="me-3">
                  <div className="form-group mb-0 filter_icon_container filter_design">
                    <i className="fa fa-filter mr-2 filter_icon"></i>
                    <div className="select-down-arrow">
                      <select
                        className="form-control cp"
                        onChange={handleFilterChange}
                        id="statusfilter"
                        style={{ width: "93px" }}
                      >
                        <option value="">Type</option>
                        {fileType.map((option, i) => (
                          <option key={i} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <button
                  type="reset"
                  className="btn btn-warning float-right mr-2"
                  onClick={resetFilter}
                >
                  Reset Filter
                </button>

                <button
                  className="btn ripple btn-main-primary signbtn"
                  onClick={() => navigate("/admin/media/add")}
                >
                  Add New
                </button>
              </div>
            </div>

            <div>
              <ul className="list-unstyled row mb-0">
                {data.map((item, index) => {
                  const fileName = item.fileName?.split(".")[0] || "";
                  return (
                    <li
                      key={index}
                      style={{ flexDirection: "column" }}
                      className="col-xs-6 col-sm-4 col-md-4 col-xl-2 mb-4 gallery-image"
                    >
                      <span className="fileName-gallery">{TrimText(fileName, 70)}</span>
                      {hasPermission("/admin/media/delete") && (
                        <div className="delete-btn">
                          <Whisper
                            placement="top"
                            controlId="control-id-hover"
                            trigger="hover"
                            speaker={<Tooltip>Delete an Image</Tooltip>}
                          >
                            <button
                              className="btn btn-warning pt-1 mt-3 pb-0"
                              style={{ background: "#f1388b", border: "0px" }}
                              onClick={() => Deletefunction(item)}
                            >
                              <i className="fa fa-trash" style={{ fontSize: "16px" }}></i>
                            </button>
                          </Whisper>
                        </div>
                      )}
                      <Link
                        className="w-100 d-flex justify-content-center align-items-center media-box"
                        state={item} to={`/admin/media/details?fileName=${item.fileName}`}
                      >
                        <UseImageLoad item={item} index={index} />
                      </Link>
                    </li>
                  );
                })}
              </ul>

              {isLoading && (
                <div className="text-center my-3">
                  <Loader />
                </div>
              )}

              {!isLoading && data.length === 0 && (
                <p style={{ textAlign: "center", fontSize: "18px" }}>No records</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Galary;
